$(function () {
  // adds anchor link to each h2 
  $('h2').each(function () {
    var $this = $(this);
    $this.attr('id', $this.text().toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, ""));
  });
  var anchorTarget = window.location.hash;
  window.location.hash = '';
  window.location.hash = anchorTarget;
});
